module.exports = __webpack_public_path__ + "img/block_2.88c7a9d0.webp";